import React, { useEffect, useRef, useState } from "react";
import { Button, Container, FormGroup, Input, Label } from "reactstrap";
import { demandInfo } from "../../../services/demandHistoryApi";
import {
  compactDateTimeFormat,
  getJSTDateStr,
} from "../../../utils/dateformatter";
import { TimeSlots } from "./TimeSlot";
import { getLatestPastSlot } from "../../../utils/timeSlotUtils";

const DashboardDate = ({
  activationDate,
  onDemandDataFetch,
  onLoadingChange,
  onDownloadCsv,
}) => {
  // const yesterdayDateTime = getYesterdayMidnightDateTimeJst();
  const today = getJSTDateStr();
  const yesterday = getJSTDateStr(-1);
  const tomorrow = getJSTDateStr(1);
  const dropdownRef = useRef(null);
  const toggleBtnRef = useRef(null);

  const [date, setDate] = useState(today);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selStartIndex, setSelStartIndex] = useState(null);
  const [selEndIndex, setSelEndIndex] = useState(null);
  const [selectedDateTimeDisplay, setSelectedDateTimeDisplay] = useState(
    getLatestPastSlot(yesterday)
  );
  const [selectedDateTimeISO, setSelectedDateTimeISO] = useState();
  // Use this if you want to display the first date and time from time slot
  // const [selectedDateTimeDisplay, setSelectedDateTimeDisplay] = useState(
  //   formatDateForInput(yesterday)
  // );
  // const [selectedDateTimeISO, setSelectedDateTimeISO] =
  // useState(yesterdayDateTime);

  const selectedDate = date ? new Date(date) : new Date();
  const prevDay = new Date(selectedDate.getTime() - 24 * 60 * 60 * 1000);
  const prevDate = new Date(date);
  prevDate.setDate(prevDate.getDate() - 1);
  const prevDateStr = prevDate.toISOString().split("T")[0];
  const isManualChange = useRef(false);

  const isDateExceed = () => {
    if (date === tomorrow) return true;
  };
  const isDateLower = () => {
    if (date === activationDate) return true;
  };

  const handleDateChange = (e) => {
    isManualChange.current = true;
    const selectedDate = e.target.value;
    setDate(selectedDate);
  };

  const handleSlotSelect = (item, index) => {
    if (item.type === "start") {
      setSelStartIndex(index);
      setSelEndIndex(null);
    } else if (item.type === "end") {
      setSelEndIndex(index);
      setSelStartIndex(null);
    }

    const dateFormatted = item.date.replace(/\//g, "-");
    const displayString = `${dateFormatted} ${item.time}`;
    setSelectedDateTimeDisplay(displayString);

    const compactDateTime = compactDateTimeFormat(displayString);
    setSelectedDateTimeISO(compactDateTime);
    setShowDropdown(false);
  };

  const formatDateForInput = (date) => {
    // return `${date} 00:00`;
    return `${date} 09:00`;
  };

  const handleDropdownClick = () => {
    setShowDropdown((prev) => !prev);
  };

  useEffect(() => {
    if (
      isManualChange.current &&
      (selectedDateTimeDisplay.split(" ")[0] === date ||
        selectedDateTimeDisplay.split(" ")[0] === prevDateStr)
    ) {
      return;
    }

    const selected = new Date(date);
    const prevDayDate = new Date(selected.getTime() - 24 * 60 * 60 * 1000);
    const newDisplay = formatDateForInput(
      prevDayDate.toISOString().split("T")[0]
    );
    const compactDateTime = compactDateTimeFormat(newDisplay);

    let finalCompactDateTime;

    if (date === tomorrow) {
      const latestSlot = getLatestPastSlot(today);
      setSelectedDateTimeDisplay(latestSlot);

      finalCompactDateTime = compactDateTimeFormat(latestSlot);
      setSelectedDateTimeISO(finalCompactDateTime);
    } else {
      setSelectedDateTimeDisplay(newDisplay);
      finalCompactDateTime = compactDateTime;
      setSelectedDateTimeISO(finalCompactDateTime);
    }

    if (isManualChange.current) {
      isManualChange.current = false;
      return;
    } else {
      fetchDemandInfo(finalCompactDateTime, selected);
    }
  }, [date]);

  const fetchDemandInfo = async (forecastDateTime, selectedDateParam) => {
    onLoadingChange?.(true);
    try {
      const response = await demandInfo({
        system_id: Number(sessionStorage.getItem("system_id")) || 2,
        request_date: selectedDateParam.toISOString().split("T")[0],
        forecast_datetime: forecastDateTime,
      });
      onDemandDataFetch?.(response.data);
    } catch (error) {
      console.error("Error fetching demand info:", error);
    } finally {
      onLoadingChange?.(false);
    }
  };

  const handleFetchData = () => {
    const currentSelectedDate = date ? new Date(date) : new Date();
    const forecastDateTime = selectedDateTimeISO;
    fetchDemandInfo(forecastDateTime, currentSelectedDate);
  };

  const handlePreviousClick = () => {
    const prevDate = new Date(date);
    prevDate.setDate(prevDate.getDate() - 1);
    const formattedDate = prevDate.toISOString().split("T")[0];
    setDate(formattedDate);
  };

  const handleNextClick = () => {
    const nextDate = new Date(date);
    nextDate.setDate(nextDate.getDate() + 1);
    const formattedDate = nextDate.toISOString().split("T")[0];
    setDate(formattedDate);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showDropdown &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        toggleBtnRef.current &&
        !toggleBtnRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showDropdown]);

  return (
    <>
      <Container fluid className="px-5">
        <div className=" date d-flex flex-wrap gap-lg-3 gap-1 align-items-center mt-3">
          <div
            className="inputForm  d-flex align-items-center "
            style={{ height: "42px" }}
          >
            <FormGroup className="d-flex align-items-center mx-2 my-3">
              <Label
                for="exampleDate"
                className="mb-0 me-2 dateSize"
                style={{ whiteSpace: "nowrap" }}
              >
                予測日
              </Label>
              <Button
                className="dateButton btn-sm"
                onClick={handlePreviousClick}
                disabled={isDateLower()}
              >
                前日
              </Button>
              <div className="d-flex align-items-center dateBorder">
                <Input
                  id="exampleDate"
                  name="date"
                  type="date"
                  value={date}
                  onChange={handleDateChange}
                  min={activationDate}
                  max={tomorrow}
                  className={`dateInput ${date ? "filled" : ""}`}
                />

                <img
                  src="./calendar select button.png"
                  className="ms-1 cursor-pointer"
                  onClick={() =>
                    document.getElementById("exampleDate").showPicker?.()
                  }
                />
              </div>
              <Button
                className="dateButton btn-sm"
                onClick={handleNextClick}
                disabled={isDateExceed()}
              >
                翌日
              </Button>
            </FormGroup>

            <div style={{ borderLeft: "2px solid #ccc", height: "30px" }}></div>

            <FormGroup
              className="d-flex align-items-center mx-2 my-3"
              style={{ position: "relative" }}
            >
              <Label
                for="exampleDateTime"
                className="mb-0 me-2 dateSize"
                style={{ whiteSpace: "nowrap" }}
              >
                予測作成日時
              </Label>

              <Input
                id="exampleDateTime"
                name="datetime"
                type="text"
                readOnly
                value={selectedDateTimeDisplay}
                className={`dateTimeInput ${date ? "filled" : ""} dateTimeFont`}
              />

              <img
                ref={toggleBtnRef}
                src="./dropdown select button.png"
                className="ms-1"
                style={{ cursor: "pointer" }}
                onClick={handleDropdownClick}
              />

              {showDropdown && (
                <div
                  ref={dropdownRef}
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: "0",
                    background: "white",
                    border: "1px solid #ccc",
                    zIndex: 1000,
                  }}
                >
                  <TimeSlots
                    startDate={prevDay.toISOString().split("T")[0]}
                    endDate={selectedDate.toISOString().split("T")[0]}
                    onSelect={handleSlotSelect}
                    selStartIndex={selStartIndex}
                    selEndIndex={selEndIndex}
                    selectedDateTimeDisplay={selectedDateTimeDisplay}
                  />
                </div>
              )}
            </FormGroup>
          </div>

          <Button className="displayButton btn-sm" onClick={handleFetchData}>
            表示更新
          </Button>
          <Button className="displayButton btn-sm" onClick={onDownloadCsv}>
            EXCEL出力
            <img src="./Download.png" alt="download" />
          </Button>
        </div>
      </Container>
    </>
  );
};

export default DashboardDate;
